import React, { useEffect } from "react";

import { Modal, Button, Col, Row } from "react-bootstrap";

import "rc-time-picker/assets/index.css";
import moment from "moment";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { RenderTextInput, RenderCheckboxInput } from "app/common/renderInput";
import { model, validationEditModel } from "./EditPopupModel";
import { SimpleCard } from "@gull";
import { updateCharter } from "app/services/charterService";
import { NotificationManager } from "react-notifications";
import { TimePicker } from "antd";

const format = "hh:mm ";

const now = moment().hour(0).minute(0);

const EditModal = ({
  showEditModal,
  EditModalClose,
  flightData,
  refreshData,
  selectedId,
}) => {
  const submitEdiCharterForm = async (values) => {
    console.log(values);

    debugger;
    try {
      const data = await updateCharter(values);
      if (data) {
        console.log(data);
        NotificationManager.success("Updated Successfully.");
        refreshData(selectedId);
        EditModalClose();
      }
    } catch (error) {
      NotificationManager.error(error);
      console.log(error);
    }
  };
  return (
    <Formik
      initialValues={flightData}
      validationSchema={validationEditModel}
      onSubmit={submitEdiCharterForm}
      enableReinitialize
    >
      {(formik) => {
        const {
          values,
          handleChange,
          handleSubmit,
          errors,
          touched,
          handleBlur,
          isValid,
          dirty,
          setFieldValue,
        } = formik;

        return (
          <Modal show={showEditModal} size="lg" scrollable={true}>
            <Modal.Header>
              <Modal.Title>
                Edit Series Flight ({flightData?.flightDate?.split("T")[0]})
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <form
                className="needs-validation"
                onSubmit={handleSubmit}
                noValidate
              >
                <div className="row mb-2">
                  <div className="col-6">
                    <label htmlFor="departureTime">Departure Time</label>
                    <TimePicker
                      name="departureTime"
                      value={
                        values.departureTime
                          ? moment(values.departureTime, "HH:mm:ss")
                          : ""
                      }
                      className="form-control"
                      use24Hours
                      onChange={(time, timeString) => {
                        setFieldValue(`departureTime`, timeString);
                      }}
                      format={"HH:mm"}
                    />
                    {touched.departureTime && errors.departureTime && (
                      <div>
                        <small className="text-danger">
                          {errors.departureTime}
                        </small>
                      </div>
                    )}
                  </div>

                  <div className="col-6">
                    <label htmlFor="arrivalTime">Arrival Time</label>
                    <TimePicker
                      name="arrivalTime"
                      className="form-control"
                      use24Hours
                      value={
                        values.arrivalTime
                          ? moment(values.arrivalTime, "HH:mm:ss")
                          : ""
                      }
                      onChange={(time, timeString) => {
                        setFieldValue(`arrivalTime`, timeString);
                      }}
                      format={"HH:mm"}
                    />
                    {touched.arrivalTime && errors.arrivalTime && (
                      <div>
                        <small className="text-danger">
                          {errors.arrivalTime}
                        </small>
                      </div>
                    )}
                    {""}
                  </div>
                </div>
                <div className="row">
                  {/* <RenderTextInput
                      type="text"
                      
                      display="check In Baggage"
                      name="checkInBaggage"
                      value={flightData.checkInBaggage}
                      //value={values.checkInBaggage}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={errors.checkInBaggage}
                      touched={touched.checkInBaggage}
                      required
                    ></RenderTextInput> */}
                  <RenderTextInput
                    type="number"
                    name="seat"
                    display="Seats"
                    value={values.seat}
                    error={errors.seat}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    touched={touched.seat}
                    required
                  ></RenderTextInput>

                  <RenderTextInput
                    type="text"
                    name="pnr"
                    display="PNR"
                    value={values.pnr}
                    error={errors.pnr}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    touched={touched.pnr}
                  ></RenderTextInput>
                </div>

                <div className="row">
                  <RenderCheckboxInput
                    type="switch"
                    name="isActive"
                    display="Active"
                    value={values.isActive}
                    error={errors.isActive}
                    //  onChange={handleChange}
                    onBlur={handleBlur}
                    touched={touched.isActive}
                    required
                    onChange={(e) => {
                      setFieldValue("isActive", e.currentTarget.checked);
                    }}
                  ></RenderCheckboxInput>

                  <RenderCheckboxInput
                    type="switch"
                    name="refundable"
                    display="Refundable"
                    value={values.refundable}
                    error={errors.refundable}
                    //onChange={handleChange}
                    onBlur={handleBlur}
                    touched={touched.refundable}
                    required
                    onChange={(e) => {
                      setFieldValue("refundable", e.currentTarget.checked);
                    }}
                  ></RenderCheckboxInput>
                </div>

                {/* Adult Fare */}
                <h5 className="mt-4">Adult Fare (Per Seat)</h5>
                <Row className="form-row">
                  <Col xs={12} md={4}>
                    <RenderTextInput
                      type="number"
                      display="Total Base Fare"
                      name="adultBaseFare"
                      value={values.adultBaseFare}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={errors.adultBaseFare}
                      touched={touched.adultBaseFare}
                      required
                      placeholder="Total Base Fare"
                    />
                  </Col>
                  <Col xs={12} md={4}>
                    <RenderTextInput
                      type="number"
                      display="Total Tax"
                      name="adultTotalTaxPerSeat"
                      value={values.adultTotalTaxPerSeat}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={errors.adultTotalTaxPerSeat}
                      touched={touched.adultTotalTaxPerSeat}
                      required
                      placeholder="Total Tax"
                    />
                  </Col>
                  <Col xs={12} md={4}>
                    <RenderTextInput
                      type="number"
                      display="Total Fare (Base Fare +Tax)"
                      value={values.adultTotalTaxPerSeat + values.adultBaseFare}
                      readOnly
                    />
                  </Col>
                </Row>

                {/* Child Fare */}
                <h5 className="mt-4">Child Fare (Per Seat)</h5>
                <Row className="form-row">
                  <Col xs={12} md={4}>
                    <RenderTextInput
                      type="number"
                      display="Total Base Fare"
                      name="childBaseFare"
                      value={values.childBaseFare}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={errors.childBaseFare}
                      touched={touched.childBaseFare}
                      required
                      placeholder="Total Base Fare"
                    />
                  </Col>
                  <Col xs={12} md={4}>
                    <RenderTextInput
                      type="number"
                      display="Total Tax"
                      name="childTotalTaxPerSeat"
                      value={values.childTotalTaxPerSeat}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={errors.childTotalTaxPerSeat}
                      touched={touched.childTotalTaxPerSeat}
                      required
                      placeholder="Total Tax"
                    />
                  </Col>
                  <Col xs={12} md={4}>
                    <RenderTextInput
                      type="number"
                      display="Total Fare (Base Fare +Tax)"
                      value={values.childTotalTaxPerSeat + values.childBaseFare}
                      readOnly
                    />
                  </Col>
                </Row>

                {/* Infant Fare */}
                <h5 className="mt-4">Infant Fare (Per Seat)</h5>
                <Row className="form-row">
                  <Col xs={12} md={4}>
                    <RenderTextInput
                      type="number"
                      display="Total Base Fare"
                      name="infrantBaseFare"
                      value={values.infrantBaseFare}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={errors.infrantBaseFare}
                      touched={touched.infrantBaseFare}
                      required
                      placeholder="Total Base Fare"
                    />
                  </Col>
                  <Col xs={12} md={4}>
                    <RenderTextInput
                      type="number"
                      display="Total Tax"
                      name="infrantTotalTaxPerSeat"
                      value={values.infrantTotalTaxPerSeat}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={errors.infrantTotalTaxPerSeat}
                      touched={touched.infrantTotalTaxPerSeat}
                      required
                      placeholder="Total Tax"
                    />
                  </Col>
                  <Col xs={12} md={4}>
                    <RenderTextInput
                      type="number"
                      display="Total Fare (Base Fare +Tax)"
                      value={
                        values.infrantTotalTaxPerSeat + values.infrantBaseFare
                      }
                      readOnly
                    />
                  </Col>
                </Row>
                <div className="d-flex align-items-center justify-content-center mt-3">
                  <Button
                    className="mx-1"
                    variant="outline-primary"
                    type="submit"
                  >
                    Update
                  </Button>
                  <Button variant="secondary" onClick={EditModalClose}>
                    Close
                  </Button>
                </div>
              </form>
            </Modal.Body>
          </Modal>
        );
      }}
    </Formik>
  );
};

export default EditModal;
